import { InMemoryCache, ApolloClient } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { createBookJaneRequestHeaders } from 'utils/createBookJaneRequest';
import { dynamicUriLink, http } from 'providers/ApolloProvider';

const authLink = setContext((_, { headers }) => {
  return {
    headers: createBookJaneRequestHeaders({ ...headers, 'X-DISABLE-PAGINATION-GRAPHQL': 1 }),
  };
});

export const nonPaginatedApolloClient = () =>
  new ApolloClient({
    link: authLink.concat(dynamicUriLink).concat(http),
    cache: new InMemoryCache(),
  });
